import { create } from "zustand";

export interface AddOnItem {
  id: string;
  name: string;
  price: number;
  quantity: number;
}

export interface BookingState {
  selectedPackage: string | null;
  selectedDate: Date | null;
  selectedTimeSlot: string | null;
  addOns: AddOnItem[];
  voucherCode: string;
  discountAmount: number;
  paymentType: "full" | "dp";
  language: "id" | "en";

  setSelectedPackage: (pkg: string | null) => void;
  setSelectedDate: (date: Date | null) => void;
  setSelectedTimeSlot: (slot: string | null) => void;
  addAddOn: (item: AddOnItem) => void;
  removeAddOn: (id: string) => void;
  updateAddOnQuantity: (id: string, quantity: number) => void;
  setVoucherCode: (code: string) => void;
  setDiscountAmount: (amount: number) => void;
  setPaymentType: (type: "full" | "dp") => void;
  setLanguage: (lang: "id" | "en") => void;
  resetBooking: () => void;
}

export const useBookingStore = create<BookingState>((set) => ({
  selectedPackage: null,
  selectedDate: null,
  selectedTimeSlot: null,
  addOns: [],
  voucherCode: "",
  discountAmount: 0,
  paymentType: "full",
  language: "id",

  setSelectedPackage: (pkg) => set({ selectedPackage: pkg }),
  setSelectedDate: (date) => set({ selectedDate: date }),
  setSelectedTimeSlot: (slot) => set({ selectedTimeSlot: slot }),
  addAddOn: (item) =>
    set((state) => {
      const existing = state.addOns.find((a) => a.id === item.id);
      if (existing) {
        return {
          addOns: state.addOns.map((a) =>
            a.id === item.id ? { ...a, quantity: a.quantity + 1 } : a
          ),
        };
      }
      return { addOns: [...state.addOns, { ...item, quantity: 1 }] };
    }),
  removeAddOn: (id) =>
    set((state) => ({
      addOns: state.addOns.filter((a) => a.id !== id),
    })),
  updateAddOnQuantity: (id, quantity) =>
    set((state) => ({
      addOns: state.addOns.map((a) =>
        a.id === id ? { ...a, quantity: Math.max(0, quantity) } : a
      ),
    })),
  setVoucherCode: (code) => set({ voucherCode: code }),
  setDiscountAmount: (amount) => set({ discountAmount: amount }),
  setPaymentType: (type) => set({ paymentType: type }),
  setLanguage: (lang) => set({ language: lang }),
  resetBooking: () =>
    set({
      selectedPackage: null,
      selectedDate: null,
      selectedTimeSlot: null,
      addOns: [],
      voucherCode: "",
      discountAmount: 0,
      paymentType: "full",
    }),
}));
